import en from "./en";
import th from "./th";

const translations = {
  en,
  th,
};

export default translations;
